import { render, staticRenderFns } from "./ServicesManagement.vue?vue&type=template&id=670da441&scoped=true"
import script from "./ServicesManagement.vue?vue&type=script&lang=js"
export * from "./ServicesManagement.vue?vue&type=script&lang=js"
import style0 from "./ServicesManagement.vue?vue&type=style&index=0&id=670da441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_xsnsr4smgwphgcec6u2nh24t5a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670da441",
  null
  
)

export default component.exports